import React from 'react';

import ExportAuditLogButton from 'audit/ExportAuditLogButton';
import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import {ButtonStyle} from 'ui-library/buttons/Button';
import {Header1} from 'ui-library/Headers';
import licenses from 'user/Licenses';

interface ResultsHeaderProps {
  modelId: string;
}

export function ResultsHeader(props: ResultsHeaderProps): JSX.Element {
  const renderExportAuditLogButton = (): JSX.Element | null => {
    if (!licenses.hasEnterprisePlan()) {
      return null;
    }

    return (
      <ExportAuditLogButton
        ids={[]}
        additionalOptions={{relatedResultsModelId: props.modelId}}
        className="metadata-header-button-spacing-left"
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
      />
    );
  };

  return (
    <div className="u-lr-split" {...getTestProps({component: 'ResultsHeader', element: 'root'})}>
      <Header1>{MODEL_NAMES.Results}</Header1>
      {renderExportAuditLogButton()}
    </div>
  );
}
